import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getDocumentSummaryRpc } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsSummarizationService';
const BASE_URL = 'presentations/v1/deck-summary/deck';
export function fetchDocumentDescriptionCHIRP({
  deckId
}) {
  const rpcClient = createRpcClientV2({
    hubHttpClient: http
  });
  const request = {
    documentId: deckId
  };
  return rpcClient.call(getDocumentSummaryRpc, {
    request
  });
}
export function fetchDocumentDescriptionREST({
  deckId
}) {
  return http.get(`${BASE_URL}/${deckId}`);
}
export function updateDocumentDescription({
  deckId,
  text,
  isUserEdited
}) {
  return http.put(`${BASE_URL}/${deckId}`, {
    data: {
      text,
      isUserEdited
    }
  });
}
export function generateDocumentDescription({
  deckId,
  options
}) {
  return http.post(`${BASE_URL}/${deckId}/summarize`, {
    data: options
  });
}
export function submitDocumentDescriptionFeedback({
  correlationId,
  vote,
  selectedFormOptions,
  feedbackMessage
}) {
  return http.post('presentations/v1/deck-summary/feedback', {
    data: {
      correlationId,
      vote,
      feedbackGeneric: selectedFormOptions,
      feedbackFreeform: feedbackMessage
    }
  });
}